// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__28lAZ","footer":"styles_footer__33rCE"};